// Как публичная ссылка должна открыться у читателя: снимок вида автора —
// язык, палитра и обе ступени размера.
//
// Отдельным хуком, потому что ссылку копируют из двух мест: из окна «поделиться»
// и из списка поездок. Собирать этот снимок в каждом из них — верный способ
// однажды разослать ссылки, открывающиеся по-разному в зависимости от того,
// какой кнопкой их скопировали.
import { useMemo } from 'react';
import { useI18n } from '../i18n';
import { useTheme } from '../theme';
import type { ShareView } from './api';

export function useShareView(): ShareView {
  const { lang } = useI18n();
  const { theme, fontScaleIndex, spaceScaleIndex } = useTheme();
  return useMemo(
    () => ({ lang, appearance: { theme, fontScaleIndex, spaceScaleIndex } }),
    [lang, theme, fontScaleIndex, spaceScaleIndex],
  );
}
